// 定义Modal组件的类型
import React, {useContext} from "react";
import CustomPopup from "../../../../components/CustomPopup";
import '../../../../global/css/global-display.css'
import '../../../../global/css/container.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {PageEnum} from "../../../../types/IPage.ts";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    switchPage: (page: PageEnum) => void,
};
const LoginModal: React.FC<Props> = ({isOpen, onClose, switchPage}) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div
                className="width-300 height-260 bg-color-white display-fixed-center border-radius-10 display-flex-column">
                <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                     alt="pic"/>
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl}
                     alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                <div className="margin-left-right-auto margin-top-100 my-roboto-regular font-size-16 color-black-custom">
                    Log in to see more
                </div>
                <div onClick={() => switchPage(PageEnum.LOGIN)}
                     className="margin-left-right-auto margin-top-66 height-38 width-113 text-center bg-color-blue-btn color-white my-roboto-medium font-size-14 display-flex-row display-flex-align-items-center display-flex-justify-content-center border-radius-34">Log
                    In
                </div>
            </div>
        </CustomPopup>
    );
};

export default LoginModal;